export default __webpack_public_path__ + "static/media/Read-Light_V1100.76a62b45.woff2";